const fashionunitedOrigins = new Set([
  'https://au.fashionunited.com',
  'https://fashionunited.be',
  'https://fashionunited.ca',
  'https://fashionunited.ch',
  'https://fashionunited.cl',
  'https://fashionunited.cn',
  'https://fashionunited.co',
  'https://fashionunited.com.ar',
  'https://fashionunited.com.pe',
  'https://fashionunited.com',
  'https://fashionunited.de',
  'https://fashionunited.es',
  'https://fashionunited.fr',
  'https://fashionunited.in',
  'https://fashionunited.info',
  'https://fashionunited.it',
  'https://fashionunited.mx',
  'https://fashionunited.nl',
  'https://fashionunited.nz',
  'https://fashionunited.ru',
  'https://fashionunited.uk',
  'https://fashionweekweb.com',
  'https://internationalfashionjobs.com',
]);

export default () => fashionunitedOrigins
  .has(window.location.origin.replace(/\/\/(qa|review-[\w-]+)[.-]/, '//'));
